export default __webpack_public_path__ + "static/media/biote_finish.892af224.png";